import moment from 'moment';
import 'moment-timezone';

const timeZone = 'America/Sao_Paulo';

export default function formatDateTime(value) {
  if (value) return moment(value).tz(timeZone).format('DD/MM/YYYY HH:mm');
  return undefined;
}
